import { ContentItemTypes, mapToStep1Type } from "../../../../src/stepTree";
import PatcraftApi from "../../../scripts/patcraft-api";
import { globalIcons } from "../../../constants/global";
import commonMethods from "../../../scripts/common-methods";


const state = () => ({
  productType: [],
  step: 1,
  step1: {
    selectedType: null,
  },
  paint: {
    selectedPaints: [],
    preselectedPaints: [],
  },
  type: ContentItemTypes,
  isOutsideBoard: true,
  title: '',
  board: {
    id: '',
    createdAt: '',
    updatedAt: '',
    title: '',
    titlePosition: '',
    applyFilter: true,
    description: '',
    isPrivate: false,
    isBrandBoard: false,
  },
  boards: [],
  StyleNumber: '',
  searchTerm: '',
  nodeAlias: null,
  userBoards: [],
  product: {
    productId: '',
    productStyleImages: [],
    savedImages: [],
    productInventoryType: '',
    productType: '',
  },
  initialStep2: {
    productType: '',
    selectedProduct: null,
    searchTerm: '',
    sectionId: '',
    results: [],
    filteredResults: [],
    productTypes: {},
    isItemSelected: false,
  },
  step2: {
    sectionId: '',
    productType: '',
    selectedProduct: null,
    searchTerm: '',
    sectionId: '',
    results: [],
    filteredResults: [],
    productTypes: '',
    isItemSelected: false
  },
  contentItem: {
    title: '',
    description: '',
    coverPhoto: '',
    coverPhotoImageAltText: '',
    thumbnailUrl: '',
    link: '',
    type: ContentItemTypes.product,
    size: 0,
    row: 0,
    column: 0,
    sectionId: '',
    isItemSelected: false,
    seoUrl: '',
    collectionCode: '',
    itemBoardId: ''
  },
  selectedTrayId: "",

  step3: [],

  step4: '',

  paint: {
    selectedPaints: [],
    preselectedPaints: [],
  },
  boardStep: {
    searchTerm: '',
    page: 1,
    results: [],
    resultsCount: null,
    loadingStatus: 0,
    loadingMoreStatus: 0,
    selectedIndex: null,
    sectionId: '',
  },

  filterForProductSearch: {
    InventoryType: "Resilient",
    OrderColumn: "OriginalActivationDate",
    PageNumber: 1,
    IncludeTotalResultCount: true,
    PageSize: 400,
    InStock: null,
    SearchTerm: null,
    IsAscendingOrder: false,
    IsEnabledOnSite: true,
    IsDisabledOnSearch: false,
    FaceWeightMin: null,
    FaceWeightMax: null,
    IsPSP: true
  },
  filterForProductType: {
    InventoryType: "Resilient",
    OrderColumn: "OriginalActivationDate",
    PageNumber: 1,
    IncludeTotalResultCount: true,
    PageSize: 400,
    InStock: null,
    SearchTerm: null,
    IsAscendingOrder: false,
    IsEnabledOnSite: true,
    IsDisabledOnSearch: false,
    FaceWeightMin: null,
    FaceWeightMax: null,
    IsPSP: true
  },
  isProductSearchDisabled: false,
  productSearchResponse: [],
  selectedProduct: null,
  selectedColorNumber: null,
  selectedRoomSceneId: '',
  productItemDetails: null,
  radioOptions: [
    { label: 'Small', value: 0 },
    { label: 'Medium', value: 1 },
    { label: 'Large', value: 2 },
  ],
  documentRadioOptions: [{ label: "Small", value: 0 }],
  inspirationGalleryParam: {
    OrderColumn: "DisplayCollectionName",
    SortBy: "DisplayCollectionName",
    PageNumber: 1,
    IncludeTotalResultCount: true,
    PageSize: 6,
    SearchTerm: null,
    IsAscendingOrder: false
  },
  documenPayload: {
    OrderColumn: "LastModifiedDate",
    DocumentType: "",
    PageNumber: 1,
    IncludeTotalResultCount: true,
    PageSize: 100,
    SearchTerm: "",
    IsAscendingOrder: false
  },
  resourceString: "",
  inspirationGalleryImages: [],
  imageTypeFilters: [],
  documentFilters: [],
  totalPage: 0,
  loader: false,
  selectedDocument: [],
  documentData: [],
  allWebPages: [],
  allProjects: [],
  allProjectsTotalCount: 0,
  isStep2ItemSelected: false,
  chosenProject: {
    id: ''
  },
  webPagesSuggestions: [],
  selectedWebPage: {},
  errorMsg: '',
  projectAlreadyExist: '',
  isOutOfProject: false,
  userIsAuthenticated : localStorage.getItem('userIsAuthenticated'),
  projectDetails:[]
})

// Getters
const getters = {
  getuserIsAuthenticated: state =>{
    return state.userIsAuthenticated;
  },
  getProjectDetails: state =>{
    return state.projectDetails;
  },

  getContentWizardData: state => {
    return state;
  },
  getProductSearchTerm: state => {
    return state.filterForProductSearch.SearchTerm;
  },
  getFilterForProductSearch: state => {
    return state.filterForProductSearch;
  },
  getisProductSearchDisabled: state => {
    return state.isProductSearchDisabled;
  },
  getproductSearchResponse: state => {
    return state.productSearchResponse;
  },
  getSelectedProduct: state => {
    return state.selectedProduct;
  },
  getselectedTrayId: state => state.selectedTrayId,
  getSelectedDocument: state => state.selectedDocument,

  getContentItem: state => state.contentItem,

  getinspirationGalleryImages: state => state.inspirationGalleryImages,

  getDocumentData: state => state.documentData,

  getimageTypeFilters: state => state.imageTypeFilters,
  getDocumentFilters: state => state.documentFilters,

  getShowLoadMore: state => {
    return (
      state.totalPage > state.inspirationGalleryParam.PageNumber ||
      (state.loader && state.inspirationGalleryImages.length === 0)
    );
  },

  getDocumentLoadMore: state => {
    return (
      state.totalPage > state.documenPayload.PageNumber ||
      (state.loader && state.documentData.length === 0)
    );
  },

  getLoader: state => {
    return state.loader;
  },
}

// Mutations
const mutations = {
  setCommonErrorMsg(state, data) {
    state.errorMsg = data
  },
  setSelectedRoomSceneId(state, roomId) {
    state.selectedRoomSceneId = roomId;
  },
  setProductType(state, data) {
    let type = data.find(item => item.name == 'Product Type')
    state.productType = type?.options?type?.options:[];
  },
  setProductSearchResponse(state, { data }) {
    state.productSearchResponse = data;
  },
  resetContentType(state) {
    state.board = state.board,
      state.boards = state.boards,
      state.step = state.step,
      state.step2 = {
        ...state.initialStep2,
        sectionId: state.step2.sectionId,
      },
      state.contentItem = {
        description: state.contentItem.description
      },

      state.isOutsideBoard = state.isOutsideBoard

  },

  resetContent(state, data = {}) {
    state.step = data.step != null ? data.step : 1,
      state.step2 = { ...state.initialStep2 },
      state.step3 = [],
      state.step4 = '',
      state.isProductSearchDisabled = false,
      state.productItemDetails = null,
      state.selectedRoomSceneId = null,
      state.contentItem = {
        title: data.title != null ? data.title : '',
        description: data.description != null ? data.description : '',
        coverPhoto: data.coverPhoto != null ? data.coverPhoto : '',
        coverPhotoImageAltText: data.coverPhotoImageAltText != null ? data.coverPhotoImageAltText: '',
        thumbnailUrl: data.thumbnailUrl != null ? data.thumbnailUrl : '',
        link: data.link != null ? data.link : '',
        type: data.type != null ? data.type : ContentItemTypes.product,
        size: 0,
        row: 0,
        column: 0,
        sectionId: '',
        isItemSelected: false,
        seoUrl: '',
        collectionCode: '',
        itemBoardId: ''
      },
      state.selectedDocument = null,
      state.documentData = [],
      state.inspirationGalleryImages = [],
      state.selectedWebPage = {},
      state.chosenProject.id = '',
      state.allProjects = []
  },

  setStep(state, step) {
    state.step = step

  },
  setContentType(state, type) {
    state.contentItem = { ...state.contentItem, type };
    state.step1.selectedType = mapToStep1Type(type);
  },
  setContentItem(state, data) {
    state.contentItem = { ...state.contentItem, ...data }

  },
  setStep1(state, step1) {
    state.step1 = { ...state.step1, ...step1 };
  },
  setStep2(state, data) {
    state.step2 = { ...data };

  },
  setStep3(state, data) {
    state.step3 = data;
  },
  setStep4(state, data) {
    state.step4 = data;
  },
  updateProductSearchTerm(state, data) {
    state.filterForProductSearch.InventoryType = data;
  },

  isDisabledProductSearch(state, data) {
    state.isProductSearchDisabled = data
  },
  selectedProduct(state, data) {
    state.selectedProduct = data;
  },
  setSelectedColorNumber(state, data) {
    state.selectedColorNumber = data;
  },
  setProductItemDetails(state, data) {
    state.productItemDetails = data;
  },
  setselectedTrayId(state, data) {
    state.selectedTrayId = data
  },
  setSearchInput(state, data) {
    state.inspirationGalleryParam.SearchTerm = data;
  },
  setDocumentSearchInput(state, data) {
    state.documenPayload.SearchTerm = data;
  },
  setPageNumber(state, initialPage) {
    if (initialPage) {
      state.inspirationGalleryParam.PageNumber = 1;
    } else {
      state.inspirationGalleryParam.PageNumber = state.inspirationGalleryParam.PageNumber + 1;
    }
  },
  setDocumentPageNumber(state, initialPage) {
    if (initialPage) {
      state.documenPayload.PageNumber = 1;
    } else {
      state.documenPayload.PageNumber = state.documenPayload.PageNumber + 1;
    }
  },

  setselectedOption(state, data) {
    state.inspirationGalleryParam.SortBy = data;
    state.inspirationGalleryParam.OrderColumn = data;
  },
  setSelectedDocumentOption(state, data) {
    state.documenPayload.DocumentType = data;
  },
  setinspirationGalleryImages(state, { data }) {
    state.imageTypeFilters = data.imageTypeFilters
    if (state.inspirationGalleryParam.PageNumber > 1) {
      state.inspirationGalleryImages = [...state.inspirationGalleryImages, ...data.items];
    } else {
      state.inspirationGalleryImages = [...data.items];
    }
  },


  setDocumentResp(state, { data }) {
    state.documentFilters = data?.result?.documentType;
    const finalResponse = [];
    let documentType = state.documenPayload.DocumentType;
    data?.result?.items?.forEach((item) => {
      const links = getLinks(item, documentType);

      if ((links && links.length > 0)) {
        finalResponse.push(...links);
      }
    });

    if (state.documenPayload.PageNumber > 1) {
      state.documentData = [...state.documentData, ...finalResponse];
    } else {
      state.documentData = [...finalResponse];
    }
  },

  setInspirationGalleryTotalPage(state, { data }) {
    state.totalPage = Math.ceil(data?.totalCount / data?.pageSize);
  },
  setDocumentTotalPage(state, { data }) {
    state.totalPage = Math.ceil(data?.result?.totalCount / data?.result?.pageSize);
  },
  updateLoader(state, data) {
    state.loader = data;
  },
  setSelectedDocument(state, data) {
    state.selectedDocument = data;
  },
  setResourceString(state, data) {
    state.resourceString = data;
  },
  setProjectAlreadyExistRString(state, data) {
    state.projectAlreadyExist = data;
  },
  setAllProjects(state, data) {
    state.allProjects = data;
    state.chosenProject.id = '';
  },
  setProjectDetails(state, data) {
    state.projectDetails = data;
  },


}

// Actions
const actions = {

  setProjectDetails({ commit }, data) {
    commit("setProjectDetails", data)
  },
  setAllProjects({ commit }, data) {
    commit("setAllProjects", data)
  },
  commonErrorMsg({ commit }, data) {
    commit("setCommonErrorMsg", data)
  },
  setColors({ commit }, data) {
    commit('selectedProduct', data);
  },
  selectProject({commit, state}, data){
    state.chosenProject = data;
  },
  setIsOutOfProject({commit, state}, data){
    state.isOutOfProject = data;
  },
  setIsStep2ItemSelected({commit, state}, data){
    state.isStep2ItemSelected = data;
  },
  async getAllProjects({ commit, state, dispatch }, data) {
    await PatcraftApi.getAllVirtualTray({
      isAdmin: true,
      culture: 'en-us',
      pageNumber: data.pageNumber,
      pageSize: 9,
      sortBy: 'UpdatedAt',
      sortByAsc: false,
      type: data.type,
      searchTerm: data.searchTerm,
      brandBoardType: '',
      siteProjectName: 'ProjectFeature'
    })
    .then(res => {
      state.allProjectsTotalCount = res.data.filter.totalCount;
      if(res.data?.boards.length > 0)
      {
        if(data.pageNumber != 1)
        {
          state.allProjects = [...state.allProjects, ...(res.data?.boards)];
        }
        else{
          state.allProjects = res.data?.boards;
        }
      }
      else{
        state.allProjects = [];
      }
    })
    .catch(err => {
      state.allProjectsTotalCount = 0;
      state.allProjects = [];
      commonMethods.handleCatch(dispatch, commit, new Error(err), state, true);
    })
  },

  async getProductStyleNumbers({ commit, dispatch, state }, data) {
    await PatcraftApi.searchProduct(data)
      .then(res => {
        commit("selectedProduct", res.data?.items[0])
      })
      .catch(error => {
        commonMethods.handleCatch(dispatch, commit, new Error(error), state, false);
      });
  },

  async getConstructionSpec({ commit, dispatch, state }, data) {
    await PatcraftApi.getConstructionSpec(data)
      .then(res => {
      })
      .catch(error => {
        commonMethods.handleCatch(dispatch, commit, new Error(error), state, false);
      });
  },

  setSelectedRoomScene({ commit }, roomId) {
    commit("setSelectedRoomSceneId", roomId);
  },
  setProductItemDetails({ commit }, data) {
    commit("setProductItemDetails", data);
  },
  selectedProduct({ commit }, data) {
    commit('selectedProduct', data)
  },
  resetContentType({ commit }) {
    commit('resetContentType')
  },
  resetContent({ commit }, data) {
    commit('resetContent', data)
  },
  setStep({ commit }, step) {
    commit('setStep', step)
  },
  setContentType({ commit }, type) {
    commit('setContentType', type)
  },

  setStep1({ commit }, step1) {
    commit('setStep1', step1)
  },
  setStep2({ commit }, data) {
    commit('setStep2', data)
  },

  setStep3({ commit }, data) {
    commit('setStep3', data)
  },
  setStep4({ commit }, data) {
    commit('setStep4', data)
  },

  setSelectedColorNumber({ commit }, data) {
    commit('setSelectedColorNumber', data)
  },
  async fetchProductType({ commit, state, dispatch }) {
    await PatcraftApi.getProductFilters({ filter: { ...state.filterForProductType, PageSize: 0 } })
      .then(res => {
        commit('setProductType', res.data);
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, false);
      });
  },
  updateProductSearchTerm({ commit }, data) {
    commit("updateProductSearchTerm", data)
  },
  async fetchproductSearch({ commit, state, dispatch }) {
    commit("isDisabledProductSearch", false);
    await PatcraftApi.searchProduct(state.filterForProductSearch,)
      .then(res => {
        commit("setProductSearchResponse", res)
        commit("isDisabledProductSearch", true);
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, false);
      });
  },
  updateselectedTrayId({ commit }, data) {
    commit("setselectedTrayId", data)
  },
  setSelectedDocument({ commit }, data) {
    commit("setSelectedDocument", data)
  },
  setContentItem({ commit }, data) {
    commit("setContentItem", data)
  },

  async resourceString({ commit }, resourceStringData) {
    commit("setResourceString", resourceStringData)
  },

  async projectAlreadyExistRString({ commit }, resourceStringData) {
    commit("setProjectAlreadyExistRString", resourceStringData)
  },
  async loadMoreData({ commit, dispatch }) {
    await commit("setPageNumber");
  },

  async loadMoreData({ commit, dispatch }, data) {
    if (data == 'document') {
      await commit("setDocumentPageNumber");
      await dispatch("getDocumentDetails");
    } else {
      await commit("setPageNumber");
    }
  },

  async fetchImageResults({ commit, dispatch, state }, data) {
    commit("updateLoader", true);
    await PatcraftApi.getInspirationImages(data)
      .then(res => {
        commit("setinspirationGalleryImages", res)
        commit("setInspirationGalleryTotalPage", res);
      })
      .catch(error => {
        commonMethods.handleCatch(dispatch, commit, new Error(error), state, false);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  async updateInspirationGalleryImages({ commit, dispatch, state }) {
    commit("updateLoader", true);
    await PatcraftApi.getInspirationImages(state.inspirationGalleryParam)
      .then(res => {
        commit("setinspirationGalleryImages", res)
        commit("setInspirationGalleryTotalPage", res);
      })
      .catch(error => {
        commonMethods.handleCatch(dispatch, commit, new Error(error), state, false);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  async getDocumentDetails({ commit, dispatch, state }) {
    commit("updateLoader", true);
    await PatcraftApi.fetchDocumetDetails(state.documenPayload,)
      .then(res => {
        commit("setDocumentTotalPage", res);
        commit("setDocumentResp", res)
      })
      .catch(error => {
        commonMethods.handleCatch(dispatch, commit, new Error(error), state, false);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  async createDocumentItem({ commit, dispatch, state }, payload) {
    commit("updateLoader", true);
    let status = false;
    await PatcraftApi.addMultipleDocument(payload)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );
        status = true;
      })
      .catch(err => {
        status = false;
        const error = new Error(err);
        const statusCode = parseInt(error.message.split(" ").pop());
        if (statusCode == 409) {
          dispatch(
            "notifications/add",
            {
              type: "success",
              title: state.projectAlreadyExist,
              description: ""
            },
            { root: true }
          );
        } else {
          commonMethods.handleCatch(dispatch, commit, error, state, true);
        }
      })
      .finally(() => {
        commit("updateLoader", false);
      });
    return status;
  },
  async updateSearchInput({ commit, dispatch }, searchInput) {
    commit("setSearchInput", searchInput);
    commit("setPageNumber", true);
  },

  async updateSelectedImageType({ commit, dispatch }, selectedOption) {
    commit("setselectedOption", selectedOption);
    commit("setPageNumber", true);
  },

  selectWebPage({ commit, state }, data) {
    state.selectedWebPage = data
  },

  GetWebPages({ commit, state, dispatch }) {
    PatcraftApi.GetWebPages({
      pageSize: 1000
    }).then((res) => {
      if (res.status == 200 && res.data) {
        state.allWebPages = res.data.webPages;
      }
    }).catch((error) => {
      commonMethods.handleCatch(dispatch, commit, new Error(error), state, false);
    })
  },

  GetSuggestions({ commit, state, dispatch }, SearchTerm) {
    state.webPagesSuggestions = [];
    PatcraftApi.GetSuggestions({
      "SortBy": "pageName",
      "PageNumber": 1,
      "PageSize": 1000,
      "SearchTerm": SearchTerm
    }).then((res) => {
      if (res.status == 200 && res.data.isSuccess) {
        state.webPagesSuggestions = res.data.data;
      }
    }).catch((err) => {
      commonMethods.handleCatch(dispatch, commit, new Error(err), state, false);
    })
  },

  GetPageUrl({ commit, state, dispatch }, pageUrl) {
    state.webPagesSuggestions = [];
    PatcraftApi.GetSuggestions({
      "SortBy": "pageName",
      "PageNumber": 1,
      "PageSize": 100,
      "pageUrl": pageUrl
    }).then((res) => {
      if (res.status == 200 && res.data.isSuccess) {
        if(res?.data?.data[0]?.pageName){
          state.selectedWebPage = res?.data?.data[0];
        }
        else{
          state.selectedWebPage = {
            pageImageSrc: '',
            pageName: document.getElementsByTagName('title')[0]?.textContent != undefined ? document.getElementsByTagName('title')[0]?.textContent : '',
            pageUrl
          }
        }
      }
    }).catch((err) => {
      commonMethods.handleCatch(dispatch, commit, new Error(err), state, false);
    })
  },

  async documentSearchInput({ commit, dispatch }, searchInput) {
    commit("setDocumentSearchInput", searchInput);
    commit("setDocumentPageNumber", true);
  },

  async updateSelectedDocumentType({ commit, dispatch }, selectedOption) {
    commit("setSelectedDocumentOption", selectedOption);
    commit("setDocumentPageNumber", true);
    dispatch("getDocumentDetails");
  },

}

// Helper function get object

function finalResults(item, link, icon, title) {
  if (link) {
    return {
      icon: icon,
      title: title,
      link: link,
      sellingStyleName: item.sellingStyleName,
      sellingStyleNumber: item.sellingStyleNumber
    }
  } else {
    return null;
  }
}


function getLinks(item, documentType) {
  let links = [];
  if (!documentType) {

    // Installation Links
    if (item.installationLinks && item.installationLinks.length > 0) {
      item.installationLinks.forEach(link => {
        links.push(finalResults(
          item,
          link.link,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconInstallation),
          `${link.name}-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      });
    }

    // Maintenance Links
    if (item.maintenanceLinks && item.maintenanceLinks.length > 0) {
      item.maintenanceLinks.forEach(link => {
        links.push(finalResults(
          item,
          link.link,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconMaintenance),
          `${link.name}-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      });
    }

    // Warranty Links
    if (item.warrantyLinks && item.warrantyLinks.length > 0) {
      item.warrantyLinks.forEach(link => {
        links.push(finalResults(
          item,
          link.link,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconWarranty),
          `${link.name}-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      });
    }

    // Idea Books
    if (item.ideaBooks && item.ideaBooks.length > 0) {
      item.ideaBooks.forEach(link => {
        links.push(finalResults(
          item,
          link.filePath,
          globalIcons.IdeaBook,
          `${link.fileName}-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      });
    }

    // Look Books
    if (item.lookBooks && item.lookBooks.length > 0) {
      item.lookBooks.forEach(link => {
        links.push(finalResults(
          item,
          link.lookBookPdf,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconLookBook),
          `${link.lookBookTitle}-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      });
    }

    // Construction Specifications
    if (item.isConstructionSpecAvailable == "True") {
      links.push(finalResults(
        item,
        item.isConstructionSpecAvailable,
        'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.ConstructionSpec),
        `Construction Specifications-${item.sellingStyleName}-${item.sellingStyleNumber}`
      ));
    }

    // Sustainability Reports
    if (item.sustainabilityReportCardLink) {
      links.push(finalResults(
        item,
        item.sustainabilityReportCardLink,
        'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconSustainability),
        `Sustainability-${item.sellingStyleName}-${item.sellingStyleNumber}`
      ));
    }

    // Product Specifications
    if (item.productSpecification) {
      links.push(finalResults(
        item,
        item.productSpecification,
        'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.FullProductSpec),
        `Product Specifications-${item.sellingStyleName}-${item.sellingStyleNumber}`
      ));
    }

    return links;
  }


  switch (documentType) {
    case 'Installation':
      if (item.installationLinks && item.installationLinks.length > 0) {
        item.installationLinks.forEach(link => {
          links.push(finalResults(
            item,
            link.link,
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconInstallation),
            `${link.name}-${item.sellingStyleName}-${item.sellingStyleNumber}`
          ));
        });
      }
      return links;
    case 'Maintenance':
      if (item.maintenanceLinks && item.maintenanceLinks.length > 0) {
        item.maintenanceLinks.forEach(link => {
          links.push(finalResults(
            item,
            link.link,
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconMaintenance),
            `${link.name}-${item.sellingStyleName}-${item.sellingStyleNumber}`
          ));
        });
      }
      return links;
    case 'Warranties':
      if (item.warrantyLinks && item.warrantyLinks.length > 0) {
        item.warrantyLinks.forEach(link => {
          links.push(finalResults(
            item,
            link.link,
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconWarranty),
            `${link.name}-${item.sellingStyleName}-${item.sellingStyleNumber}`
          ));
        });
      }
      return links;
    case 'IdeaBooks':
      if (item.ideaBooks && item.ideaBooks.length > 0) {
        item.ideaBooks.forEach(link => {
          links.push(finalResults(
            item,
            link.filePath,
            globalIcons.IdeaBook,
            `${link.fileName}-${item.sellingStyleName}-${item.sellingStyleNumber}`
          ));
        });
      }
      return links;
    case 'LookBooks':
      if (item.lookBooks && item.lookBooks.length > 0) {
        item.lookBooks.forEach(link => {
          links.push(finalResults(
            item,
            link.lookBookPdf,
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconLookBook),
            `${link.lookBookTitle}-${item.sellingStyleName}-${item.sellingStyleNumber}`
          ));
        });
      }
      return links;
    case 'Construction Specifications':
      if (item.isConstructionSpecAvailable == "True") {
        links.push(finalResults(
          item,
          item.isConstructionSpecAvailable,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.ConstructionSpec),
          `Construction Specifications-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      }

      return links;
    case 'Sustainability':
      if (item.sustainabilityReportCardLink) {
        links.push(finalResults(
          item,
          item.sustainabilityReportCardLink,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.IconSustainability),
          `Sustainability-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      }
      return links;
    case 'Product Specifications':
      if (item.productSpecification) {
        links.push(finalResults(
          item,
          item.productSpecification,
          'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(globalIcons.FullProductSpec),
          `Product Specifications-${item.sellingStyleName}-${item.sellingStyleNumber}`
        ));
      }
      return links;
    default:
      return [];
  }

}



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
